import cn from 'classnames';
import { ButtonHTMLAttributes, ReactElement, ReactNode, Ref } from 'react';
import { AppearanceType, SizeType } from '../designConstants';
import { bpmBtnClassName } from '../Button';

interface DropdownToggleShellProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> {
  ref?: Ref<HTMLButtonElement>;
  appearance?: AppearanceType;
  size?: SizeType;
  leadingIcon?: ReactElement;
  label?: string | ReactElement;
  valueSlot?: ReactNode;
  indicatorsSlot?: ReactNode;
  hasError?: boolean;
}

export const DropdownToggleShell = ({
  ref,
  appearance,
  size,
  className,
  leadingIcon,
  label,
  valueSlot,
  indicatorsSlot,
  hasError,
  ...buttonPassthroughProps
}: DropdownToggleShellProps): ReactElement => (
  <button
    type='button'
    {...buttonPassthroughProps}
    ref={ref}
    className={cn(bpmBtnClassName({ appearance, size }), 'dropdown-toggle', className, {
      'has-leading-icon': Boolean(leadingIcon),
      'has-error': hasError
    })}
  >
    <div className='bpm-btn-label'>
      <div className='bpm-btn-label-content'>
        {leadingIcon && <div className='dropdown-icon'>{leadingIcon}</div>}
        {(label !== undefined || valueSlot !== undefined) && (
          <span className='dropdown-text'>
            {label && (
              <span className='dropdown-label'>
                {typeof label === 'string' ? `${label}:` : label}
              </span>
            )}
            {valueSlot}
          </span>
        )}
        {indicatorsSlot}
      </div>
    </div>
  </button>
);
